const thrpiesServiceCode = {
  Educativo: 126,
  TerapiadeHabla: 127,
  TerapiaOcupacional: 128,
  TerapiaPsicologica: 129,
  TerapiaFisica: 130,
  TerapiaABA: 658,
  TerapiaDisfagia: 662,
  TerapiaOromotora: 672,
  TerapiaEquinoTerapia: 720,
  TerapiaEducativa: 131,
};
export default thrpiesServiceCode;
